export default {
  defaultLocale: 'fr',
  locales: ['fr', 'en'],
  calendar: true,
}
